<script>
import Vue from 'vue';

Vue.component('Search', {
  data: function() {
    return {
      left: 0,
      top: 64,
      items: [],
      menus: [],
      search: '',
      active_item: 0
    };
  },
  template: `
    <div v-on:keydown="onKeyDown" :style="divStyle" v-if="$root.searchmenu" class="search-wrapper">
      <div class="input">
        <input autocomplete="off" v-on:keyup="onKeyup" type="text" name="search" value="" v-model="search" placeholder="Keresendő menüpont"/>
        <i class="fa fa-search"></i>
      </div>
      <a v-on:click="onClick" :href="'#'+item.link" v-for="(item, i) in items" class="result-item" :class="{selected: active_item == i}">
        <i class="material-icons dot">adjust</i>
        <div class="menu-name">
          {{ item.label }}
        </div>
        <div class="path" v-html="calcPath(item)">
        </div>
      </a>
    </div>
  `,
  watch: {
    '$root.searchmenu': function(nv, ov) {
      if (nv) {
        Vue.nextTick(function() {
          $('.search-wrapper input[type="text"]').focus();
        });
      }
    }
  },

  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      _this.left = $('header .search').offset().left;

      $(window).click(function(event) {
        if ($(event.target).closest('.search-wrapper').length == 0 && !$(event.target).hasClass('fa-search') && !$(event.target).hasClass('search'))
          _this.$root.searchmenu = false;
      });
    });

    this.getMenusToArray(this.$root.menus);
  },

  methods: {
    calcPath: function(item) {
      var _this = this;
      var arr = [];

      if (item.parents != undefined) {
        item.parents.map(function(id) {
          _this.menus.map(function(menu) {
            if (menu.id == id)
              arr.push(menu.label);
          });
        });
      }

      arr.push(item.label);

      return arr.join('<i class="material-icons arrow">navigate_next</i>');
    },

    onClick: function() {
      this.$root.searchmenu = false;
    },

    onKeyDown: function(event) {
      switch(event.key) {
        case "ArrowDown":
          this.active_item = (this.active_item + 1) % this.items.length;
        break;
        case "ArrowUp":
          this.active_item--;
          if (this.active_item < 0)
            this.active_item = this.items.length - 1;
        break;
        case "Enter":
          this.$router.push({path: this.items[this.active_item].link});
          this.$root.searchmenu = false;
        break;
      }
    },

    onKeyup: function() {
      var _this = this;

      if (event.key == "ArrowDown" || event.key == "ArrowUp" || event.key == "Enter" || this.search == '')
        return;

      _this.items = [];
      _this.active_item = 0;

      this.menus.map(function(menu) {
        if (menu.label.toLowerCase().indexOf(_this.search.toLowerCase()) > -1 && menu.jump == undefined && menu.link != '')
          _this.items.push(menu);
      });
    },

    getMenusToArray: function(menus) {
      var _this = this;

      menus.map(function(menu) {
        _this.menus.push(menu);

        if (menu.subs != undefined && menu.subs.length > 0)
          _this.getMenusToArray(menu.subs);
      });
    }
  },

  computed: {
    divStyle: function() {
      return {
        left: this.left + 'px',
        top: this.top + 'px'
      }
    }
  }
});
</script>


// WEBPACK FOOTER //
// search.vue?4acfd932